var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quick-entrance" },
    [
      _c("i", {
        staticClass: "el-icon-setting",
        on: {
          click: function ($event) {
            _vm.dialogShow = true
          },
        },
      }),
      _vm.dialogShow
        ? [
            _c(
              "PortalContainDialog",
              {
                attrs: {
                  "dialog-show": _vm.dialogShow,
                  title: _vm.$t("commonMenuSettings"),
                },
                on: {
                  "update:dialogShow": function ($event) {
                    _vm.dialogShow = $event
                  },
                  "update:dialog-show": function ($event) {
                    _vm.dialogShow = $event
                  },
                },
              },
              [
                _c("div", { staticClass: "dialog-container" }, [
                  _c("div", { staticClass: "entrance-search" }, [
                    _c(
                      "div",
                      { staticClass: "search-content" },
                      [
                        _c(
                          "el-autocomplete",
                          {
                            ref: "SEARCH",
                            staticClass: "inline-input",
                            attrs: {
                              "fetch-suggestions": _vm.querySearch,
                              placeholder: _vm.$t("pleaseInput"),
                              "trigger-on-focus": true,
                              "popper-append-to-body": false,
                            },
                            on: { select: _vm.handleSelect },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.serachEnter.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.serachStr,
                              callback: function ($$v) {
                                _vm.serachStr = $$v
                              },
                              expression: "serachStr",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-input__icon el-icon-search",
                              staticStyle: { "line-height": "32px" },
                              attrs: { slot: "suffix" },
                              on: { click: _vm.serachEnter },
                              slot: "suffix",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "entrance-countent" }, [
                    _c("div", { staticClass: "entrance-countent-head" }, [
                      _c("span", { staticClass: "countent-head-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("quickEntranceCollected")) +
                            " " +
                            _vm._s(_vm.routeAdded.length)
                        ),
                        _c("span", [_vm._v("/10")]),
                      ]),
                      _c("span", { staticClass: "countent-head-tips" }, [
                        _vm._v(_vm._s(_vm.$t("pressAndDrag"))),
                      ]),
                    ]),
                    _vm.routeAdded.length > 0
                      ? _c(
                          "div",
                          { staticClass: "entrance-content-list dragg-list" },
                          [
                            _c(
                              "Draggable",
                              {
                                attrs: { group: "people", animation: 300 },
                                on: {
                                  start: function ($event) {
                                    _vm.drag = true
                                  },
                                  end: function ($event) {
                                    _vm.drag = false
                                  },
                                },
                                model: {
                                  value: _vm.routeAdded,
                                  callback: function ($$v) {
                                    _vm.routeAdded = $$v
                                  },
                                  expression: "routeAdded",
                                },
                              },
                              [
                                _c(
                                  "transition-group",
                                  _vm._l(
                                    _vm.routeAdded,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.id,
                                          staticStyle: {
                                            display: "inline-block",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "list-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteRoute(
                                                    item.id,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("ElTooltipOverShow", {
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.$t(
                                                    item.translation
                                                      ? item.translation
                                                      : item.name
                                                  ),
                                                  placement: "top",
                                                  contentClass:
                                                    "list-item-title",
                                                },
                                              }),
                                              _c("i", {
                                                staticClass: "el-icon-error",
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "entrance-content-empty" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("quickEntranceAddedNull"))),
                          ]),
                        ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "entrance-countent" },
                    [
                      _c("div", { staticClass: "entrance-countent-head" }, [
                        _c("span", { staticClass: "countent-head-title" }, [
                          _vm._v(_vm._s(_vm.$t("quickEntranceTobeCollect"))),
                        ]),
                        _c("span", { staticClass: "countent-head-count" }, [
                          _vm._v(
                            _vm._s(_vm.routeCount - _vm.routeAdded.length)
                          ),
                        ]),
                      ]),
                      _c(
                        "el-tabs",
                        {
                          staticClass: "menu-tabs",
                          model: {
                            value: _vm.tobeCollectActive,
                            callback: function ($$v) {
                              _vm.tobeCollectActive = $$v
                            },
                            expression: "tobeCollectActive",
                          },
                        },
                        _vm._l(_vm.routes, function (tab, index) {
                          return _c("el-tab-pane", {
                            key: index,
                            attrs: {
                              label: _vm.$t(
                                tab.translation ? tab.translation : tab.name
                              ),
                              name: index + "",
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "entrance-content-list collected-list" },
                        _vm._l(_vm.currentRoutes, function (first) {
                          return _c(
                            "div",
                            {
                              key: first.id,
                              staticClass: "list-first",
                              class: {
                                "list-first-inline":
                                  first.children && first.children.length == 0,
                              },
                            },
                            [
                              first.children && first.children.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "list-first-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            first.translation
                                              ? first.translation
                                              : first.name
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "list-first-item" },
                                    [
                                      _vm.subrouteShow(first)
                                        ? _c(
                                            "div",
                                            {
                                              key: first.id,
                                              staticClass: "list-item",
                                              class: {
                                                "disabled—collect":
                                                  _vm.routeAdded.length === 10,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addRoute(
                                                    first,
                                                    null,
                                                    null,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("ElTooltipOverShow", {
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.$t(
                                                    first.translation
                                                      ? first.translation
                                                      : first.name
                                                  ),
                                                  placement: "top",
                                                  contentClass:
                                                    "list-item-title",
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-circle-plus",
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                              _c(
                                "div",
                                {
                                  ref: "LISTSUB",
                                  refInFor: true,
                                  staticClass: "list-sub",
                                },
                                [
                                  _vm._l(first.children, function (subroute) {
                                    return [
                                      _vm.subrouteShow(subroute)
                                        ? _c(
                                            "div",
                                            {
                                              key: subroute.id,
                                              staticClass: "list-item",
                                              class: {
                                                "disabled—collect":
                                                  _vm.routeAdded.length === 10,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addRoute(
                                                    subroute,
                                                    first,
                                                    null,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("ElTooltipOverShow", {
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.$t(
                                                    subroute.translation
                                                      ? subroute.translation
                                                      : subroute.name
                                                  ),
                                                  placement: "top",
                                                  contentClass:
                                                    "list-item-title",
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-circle-plus",
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._l(subroute.children, function (son) {
                                        return [
                                          _vm.subrouteShow(son)
                                            ? _c(
                                                "div",
                                                {
                                                  key: son.id,
                                                  staticClass: "list-item",
                                                  class: {
                                                    "disabled—collect":
                                                      _vm.routeAdded.length ===
                                                      10,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addRoute(
                                                        son,
                                                        subroute,
                                                        first,
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("ElTooltipOverShow", {
                                                    attrs: {
                                                      effect: "dark",
                                                      content: _vm.$t(
                                                        son.translation
                                                          ? son.translation
                                                          : son.name
                                                      ),
                                                      placement: "top",
                                                      contentClass:
                                                        "list-item-title",
                                                    },
                                                  }),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus",
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      }),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { attrs: { slot: "dialogFoot" }, slot: "dialogFoot" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.dialogShow = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.handleReset },
                      },
                      [_vm._v(_vm._s(_vm.$t("reset")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.handleConfrim },
                      },
                      [_vm._v(_vm._s(_vm.$t("save")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }